export default "__VITE_ASSET__RyYT2ySW__"